<template>
  <!-- 記名投票頁面儀表板區塊 -->
  <div id="TopicDashboard_main">
    <div class="main">
      <div class="topicSequenceString">
        {{ data.topicSequenceString }}
      </div>
      <div class="topicTitle">
        {{ data.topicTitle }}
      </div>
      <div
        class="topicInfo"
        @click="openTopicInfoDialog"
      >
        <span class="txt">查看議案說明</span>
        <i
          class="icon-m-next"
          aria-hidden="true"
        />
      </div>
      <el-button
        v-if="data.topicStatus == 'decided'"
        type="danger"
        class="votingButton"
        plain
        @click="resetVoting"
      >
        重新表決
      </el-button>
      <el-button
        v-if="data.topicStatus == 'voting'"
        type="danger"
        class="votingButton"
        plain
        @click="closeVoting"
      >
        結束表決
      </el-button>
      <table>
        <thead>
          <tr>
            <th>已報到總戶數</th>
            <th>投票表決基準</th>
            <th>
              <span>已投戶數</span>
              <span v-if="$route.name == 'RecordNameVoting' && isUseArea()">／{{ ratioName }}</span>
            </th>
            <th>
              <span>同意戶數</span>
              <span v-if="$route.name == 'RecordNameVoting' && isUseArea()">／{{ ratioName }}</span>
            </th>
            <th>表決結果</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="data-text">
                {{ data.tabletValue }}
              </div>
              <div class="normal-text">
                戶
              </div>
            </td>
            <td>
              <div class="data-text">
                {{ ratio(data.attendanceThreshold) }}
              </div>
              <div class="normal-text">
                ％
              </div>
            </td>
            <td>
              <div class="data-text">
                {{ data.votedNumber }}
              </div>
              <div class="normal-text">
                戶
              </div>
              <div
                v-if="$route.name == 'RecordNameVoting' && isUseArea()"
                class="normal-text"
              >
                （{{ ratio(data.votedAreaRatio) }}％）
              </div>
            </td>
            <td>
              <div class="data-text">
                {{ data.agreedNumber }}
              </div>
              <div class="normal-text">
                戶
              </div>
              <div
                v-if="$route.name == 'RecordNameVoting' && isUseArea()"
                class="normal-text"
              >
                （{{ ratio(data.agreedAreaRatio) }}％）
              </div>
            </td>
            <td>
              <div
                v-if="true"
                class="result"
              >
                {{ data.decision }}
              </div>
              <div
                v-else
                class="notControl-text"
              >
                －
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="data.thresholdSetting"
        class="tip"
      >
        <!-- 議案表決文案調整 -->
        <span>依照社區規約之規定，此議案應有</span>
        <div
          v-if="$route.name == 'RecordNameVoting'"
          class="key-text"
        >
          <span v-if="data.thresholdSetting.isUseTablet && data.thresholdSetting.isUseArea">區分所有權人及佔比達 {{ ratio(data.attendanceThreshold) }}％（{{ tabletThreshold }}戶／{{ areaThreshold }} {{ unit }}）</span>
          <span v-else-if="data.thresholdSetting.isUseTablet">區分所有權人 {{ ratio(data.attendanceThreshold) }}％（{{ tabletThreshold }}戶）</span>
          <span v-else-if="data.thresholdSetting.isUseArea">區分所有權佔比達 {{ ratio(data.attendanceThreshold) }}％（{{ areaThreshold }} {{ unit }}）</span>
        </div>
        <div
          v-else
          class="key-text"
        >
          <span>區分所有權人 {{ ratio(data.attendanceThreshold) }}％（{{ tabletThreshold }}戶）</span>
        </div>
        <span>以上且同意票數大於反對票數時，由主席宣布議案通過。</span>
      </div>
    </div>
    <TopicInfoDialog ref="topicInfoDialog" />
  </div>
</template>
<script>
import TopicInfoDialog from './TopicInfoDialog.vue'
import tw from '../../utils'
export default {
  components: {
    TopicInfoDialog
  },
  props: {
    data: Object,
    totalArea: Number
  },
  data () {
    const ratioName = tw.ratio
    const { unit } = tw
    return {
      ratioName,
      unit
    }
  },
  computed: {
    tabletThreshold () {
      return Math.ceil(this.data.tabletValue * this.data.attendanceThreshold)
    },
    areaThreshold () {
      return Math.ceil(this.totalArea * this.data.attendanceThreshold)
    },
    onlyArea () {
      // eslint-disable-next-line eqeqeq
      return this.data.thresholdSetting.isUseTablet == false && this.data.thresholdSetting.isUseArea == true
    }
  },
  mounted () {
  },
  methods: {
    closeVoting () {
      this.$confirm('結束表決後將無法再更改票數，請確認後繼續', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postCloseVoting()
      }).catch(() => {})
    },
    // 議案結束表決
    postCloseVoting () {
      apiUnitOwnerAssembly.Topic.CloseVoting(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.$message.success('議案已結束表決')
          this.$emit('refresh')
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) {
          this.$message.error(err.response.data.description)
          this.finishStep2Action()
        }
      })
    },
    // 議案重新表決
    resetVoting () {
      this.$confirm('是否清除此次投票結果，清除後將無法復原<br><br><input type="checkbox" id="resetVoting">確定清除', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if (document.getElementById('resetVoting').checked) {
              done()
            }
          } else {
            done()
          }
        }
      }).then(() => {
        if (document.getElementById('resetVoting').checked) {
          this.postResetVoting()
        }
      }).catch(() => {})
    },
    // 送出議案重新表決
    postResetVoting () {
      apiUnitOwnerAssembly.Topic.ResetVoting(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          if (this.onlyArea) {
            // 如果僅勾區權比則不跳轉去其他頁面
            // 讓會議重新進入記名投票的狀態
            apiUnitOwnerAssembly.Topic.StartVoting(
              {
                assemblyId: this.$route.params.id,
                topicId: this.$route.params.topicId,
                isAnonymous: false
              }
            ).then(() => {
              this.$message.success('此議案重新開始表決')
              console.log('僅勾區權比重新表決成功')
              // 重新表決成功後要重新整理這個頁面
              this.$emit('refresh')
            }).catch(() => {
              console.log('僅勾區權比重新表決失敗')
            })
          } else {
            // 一般流程會跳轉至投票方式選擇頁面
            this.$message.success('此議案重新開始表決，請重新選擇表決計票方式')
            this.$router.push({ name: 'TopicVoteWay', params: { id: this.$route.params.id, topicId: this.$route.params.topicId } })
          }
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    openTopicInfoDialog () {
      this.$refs.topicInfoDialog.openDialog(this.data.topicDescription)
    },
    ratio (data) {
      // eslint-disable-next-line eqeqeq
      return data == '-' ? 0 : (parseFloat((data * 100).toPrecision(12))).toFixed(2)
    },
    isUseArea () {
      if (this.data.thresholdSetting) { return this.data.thresholdSetting.isUseArea }
    }
  }
}
</script>
<style lang='sass' scoped>
#TopicDashboard_main
  +mainLayer
  padding-top: 24px
  .main
    position: relative
    .topicSequenceString
      font-size: 23px
      line-height: 32px
      font-weight: 600
      margin-bottom: 12px
    .topicTitle
      word-wrap: break-word
      font-size: 27px
      color: $mainColor
      font-weight: 600
      line-height: 38px
      margin-bottom: 9px
    .topicInfo
      margin-bottom: 24px
      line-height: 27px
      color: $mainColorDark
      cursor: pointer
      .txt
        border-bottom: $mainColorDark 1px solid
        margin-bottom: 1px
        font-size: 19px
        margin-right: 4px
    .votingButton
      position: absolute
      top: 30px
      right: 30px
      border-radius: $btnRoundBorderRadius
    table
      border: 1px solid $borderDark4
      font-size: 16px
      width: 100%
      th
        border: 1px solid $borderDark4
        padding: 12px
        font-size: 15px
        font-weight: 600
      td
        border: 1px solid $borderDark4
        padding: 12px
        line-height: 40px
        .data-text
          display: inline-block
          color: $mainFontColor
          font-size: 28px
          font-weight: 600
          vertical-align: bottom
        .normal-text
          display: inline-block
          font-size: 19px
          line-height: 40px
          margin-left: 8px
          vertical-align: bottom
          color: $subFontColor
        .result
          color: $mainColor
          font-size: 28px
          font-weight: 600
        .notControl-text
          color: $grayFontColor
          font-size: 17px
          font-weight: 600
    .tip
      margin-top: 12px
      font-size: 17px
      line-height: 24px
      color: $subFontColor
      .key-text
        display: inline-block
        font-weight: 600
        font-size: 19px
        margin: 8px 0
        color: $mainFontColor
        margin-left: 5px
</style>
